import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import EditProductionCardLayout from '../../../../components/EditComponents/EditProductionCardLayout';
import ProductionCardCollapsedContent from '../../../../components/ProductionCardCollapsedContent';
import { getFilteredTourDates, getRouteWithSlug } from '../../../../utils/common';
import TitledBlock from '../../../../components/TitledBlock';
import ListText from '../../../../components/ListText';
import { useTranslation } from '../../../../src/i18n';
import { PROFESSIONS_IDS, TP } from '../../../../constants/consts';
import route from '../../../../constants/routes';

const useStyles = makeStyles(() => ({
  contentInfoTitles: {
    display: 'flex',
  },
}));

const EditArtistProductionCard = ({
  production,
  profile,
  updatedProduction,
  onPublish,
  deleteProduction,
  editProductionLinkProps,
  setVisibility,
  removeProduction,
  isLoading,
  canEdit,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [productionToShow, setProduction] = React.useState(production);
  const [conductors] = React.useState(
    production?.crew?.filter(member => member?.profession?.id === PROFESSIONS_IDS.CONDUCTOR),
  );
  const [directors] = React.useState(
    production?.crew?.filter(member => member?.profession?.id === PROFESSIONS_IDS.STAGE_DIRECTOR),
  );

  React.useEffect(() => {
    if (updatedProduction && updatedProduction?.id === production?.id) {
      setProduction(updatedProduction);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProduction]);

  return (
    <EditProductionCardLayout
      production={productionToShow}
      onDeleteClick={deleteProduction}
      onPublishClick={onPublish}
      editLinkProps={canEdit && editProductionLinkProps(production, 1)}
      infoBlock={
        <>
          <div className={classes.contentInfoTitles}>
            <TitledBlock title={t(`${TP}.m_CONDUCTOR`)}>
              <ListText list={conductors} display="column" fontWeight="bold" fieldToDisplay="profile.name" />
            </TitledBlock>
            <TitledBlock title={t(`${TP}.m_DIR`)}>
              <ListText list={directors} display="column" fontWeight="bold" fieldToDisplay="profile.name" />
            </TitledBlock>
          </div>
          <ProductionCardCollapsedContent
            other={productionToShow?.other}
            cast={productionToShow?.casts}
            crew={productionToShow?.crew}
            tourDates={getFilteredTourDates(productionToShow?.dates)}
            showEmpty
            showText
          />
        </>
      }
      setVisibility={setVisibility}
      profile={profile}
      removeProduction={removeProduction}
      isLoading={isLoading}
      requestRedMaskLink={{
        pathname: `${getRouteWithSlug(route.ARTISTS, profile)}/edit/validation`,
        query: { production_id: production.id },
      }}
    />
  );
};

EditArtistProductionCard.propTypes = {
  production: PropTypes.object.isRequired,
  updatedProduction: PropTypes.object,
  onPublish: PropTypes.func,
  deleteProduction: PropTypes.func,
  setVisibility: PropTypes.func,
  profile: PropTypes.object,
  removeProduction: PropTypes.func,
  isLoading: PropTypes.bool,
};

EditArtistProductionCard.defaultProps = {
  updatedProduction: null,
  setVisibility: () => {},
  removeProduction: undefined,
  isLoading: false,
};

export default memo(EditArtistProductionCard);
